import { render, staticRenderFns } from "./BottomNavBar.vue?vue&type=template&id=6a452419&"
import script from "./BottomNavBar.vue?vue&type=script&lang=js&"
export * from "./BottomNavBar.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavBar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports